import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/common.translations';

const strings = new LocalizedStrings({
  en: {
    myDocuments: 'My Documents',
    uploadFile: 'Upload files',
    sections: 'Sections',
    subSections: 'Sub sections',
    categories: 'Categories',
    search: {
      emptyDesc: 'Search for a document by title or contents',
      resultsDesc: (term: string) => `Search results for '${term}'`
    },
    upload: {
      inProgress: 'Uploads in Progress',
      newFiles: 'Upload New Files',
      bulkRetry: 'Bulk Retry',
      completed: (amount: number) => `Completed (${amount})`,
      cancelled: (amount: number) => `Cancelled (${amount})`,
      failed: (amount: number) => `Failed (${amount})`
    },
    createSection: {
      title: 'Create new section',
      name: 'Section Name',
      error: {
        noName: 'Folder name must be provided',
        general: 'Unable to create new section'
      }
    }
  }
});

export default withCommon<typeof strings>(strings);
